export default __webpack_public_path__ + "static/media/spoon.a73b05ea.svg";